import middlewares from '@/middlewares/http-common';

const config = (updateProgress) => {
  return {
    onUploadProgress: (progressEvent) => updateProgress(progressEvent),
  };
};

class SenderService {
  sendClientImage(formData, updateProgress) {
    return middlewares.httpPost.put(
      '/client/images',
      formData,
      config(updateProgress),
    );
  }
  sendGalleryImages(formData, updateProgress) {
    return middlewares.httpPost.put(
      '/file-transfer/upload',
      formData,
      config(updateProgress),
    );
  }
  createSenderStream(purpose, tags, fileInfo) {
    return middlewares.httpJson.post('/file-transfer/create-upload-stream', {
      purpose,
      tags,
      fileInfo,
    });
  }
  sendByStream(
    filename,
    formData,
    startByte,
    endByte,
    totalSize,
    updateProgress,
  ) {
    return middlewares.httpPost.put(
      `/file-transfer/upload-stream/${filename}`,
      formData,
      {
        params: {
          startByte,
          endByte,
          totalSize,
        },
        onUploadProgress: updateProgress,
      },
    );
  }

  runFunctionByName(functionName) {
    if (typeof this[functionName] === 'function') {
      return this[functionName];
    } else {
      console.error('Function does not exist in this service');
      return () => {};
    }
  }
}

export default new SenderService();
